<template>
    <div>
        <h1 class="title">Direcciones de Entrega</h1>
        <delivery-address-list
                :canSelect="false"
                :canDelete="true"
        >
        </delivery-address-list>

        <h1 class="title">Direcciones de Facturación</h1>
        <billing-address-list
                :canSelect="false"
                :canDelete="true"
        >
        </billing-address-list>
    </div>
</template>

<script>
    import DeliveryAddressList from '../../components/address/DeliveryAddressList';
    import BillingAddressList from '../../components/address/BillingAddressList';

    export default {
        name: 'account-addresses',
        components: {
            BillingAddressList,
            DeliveryAddressList,
        }
    }
</script>

<style lang="scss" scoped>

</style>
